export function isFullMax({ max = Math.infinity, v = 0 } = {}) {
  return v === max
}
